export interface AuthUser {
  id: string;
  email: string;
  displayName: string;
  roleId: string;
  roleName: string;
  roleLabel: string;
  permissions: string[];
  isPlatformAdmin: boolean;
  supportMode?: boolean;
}

export interface TenantInfo {
  id: string;
  name: string;
  slug: string;
  planId: string;
  subscriptionStatus: string;
  trialEndsAt: string | null;
  graceEndsAt: string | null;
}

export function hasPermission(user: AuthUser | null, permission: string): boolean {
  if (!user) return false;
  return user.permissions.includes(permission);
}

export const PERMISSIONS = {
  dashboard: "dashboard_access",
  receipt: "equipment_receipt_access",
  request: "equipment_request_access",
  transactions: "transactions_access",
  checkout: "equipment_checkout_access",
  reports: "reports_access",
  systems: "systems_menu_access",
  adminUsers: "admin_users_access",
  adminSystems: "admin_systems_access",
  adminParts: "admin_parts_access",
  billing: "billing_access",
} as const;
